// BookSummary.jsx
import React, { useState } from 'react';
import closeButton from '../images/close-line-white.svg';
import './BookDetails.css';
import 'moment/locale/sv';
import { useTranslation } from '../i18n';

const BookSummary = ({ bookInfo, buttonClass, saving }) => {
  const [modalIsOpen, setIsOpen] = useState(false);
  const { t } = useTranslation();

  function openModal() {
    setIsOpen(true);
  }

  function closeModal() {
    setIsOpen(false);
  }

  return [
    <button className={buttonClass} onClick={openModal} key="button">
      {t.summary}
    </button>,
    modalIsOpen && (
      <div className="overlay" key="modal">
        <div className="buttons-wrapper">
          <div className="buttons-header">
            <span>{t.summary}</span>
            <button className="btn-icon" onClick={closeModal} disabled={saving}>
              <img
                className="icon"
                src={closeButton}
                width={24}
                height={24}
                alt="Close icon"
              />
            </button>
          </div>
          <div className="separator"></div>
          <div className="lh-125">{bookInfo.volumeInfo?.description}</div>
        </div>
      </div>
    ),
  ];
};

export default BookSummary;
